module.exports = __webpack_public_path__ + "static/img/账单底色.a40a4614.png";